export const ALERT_TEXT = 'This store only accepts appointments via telephone. ' +
  'Please contact the store to schedule an appointment.'
